const DEFAULT_ROOT_CLASS_NAME = 'select-box';

const item = ({ disabled, selected, text, value }) => {
    const attributes = [
        `value="${value || ''}"`,
        selected ? 'selected': '',
        disabled ? 'disabled': ''
    ].join(' ');

    return `<option ${attributes}>${text}</option>`;
};

export const items = ({ options, unselectedText }) => {
    let items = unselectedText ? item({ disabled: true, selected: true, text: unselectedText, value: '' }) : '';

    options?.forEach(option => {
        items += item({ text: option.text, value: option.value })
    });

    return items;
};

const template = ({ ariaLabel, className, id, mods, name, options, required, unselectedText }) => {
    const rootClass = className || DEFAULT_ROOT_CLASS_NAME;

    const selectAttributes = [
        ariaLabel ? `aria-label="${ariaLabel}"` : '',
        id ? `id="${id}"` : '',
        name ? `name="${name}"` : '',
        required ? 'required': ''
    ].join(' ');

    const inner = items({ options, unselectedText });

    return `
        <div class="${rootClass} ${mods}">
            <select class="${rootClass}__select" data-control="select" ${selectAttributes}>
                ${inner}
            </select>
        </div>
    `};

export default template;
